import React from 'react';
import { X, Smartphone } from 'lucide-react';
import { adminApi } from '../../lib/adminAuth';

export default function PeoplePicker({ value, onChange }) {
  const [q, setQ] = React.useState('');
  const [hits, setHits] = React.useState([]);
  React.useEffect(() => {
    const t = setTimeout(() => adminApi.get('/api/admin/push/people', { params: { q } }).then((r) => setHits(r.data)).catch(() => setHits([])), 250);
    return () => clearTimeout(t);
  }, [q]);
  const key = (p) => `${p.user_type}-${p.user_id}`;
  const picked = new Set(value.map(key));
  const add = (p) => { if (!picked.has(key(p))) onChange([...value, p]); };

  return (
    <div className="space-y-2" data-testid="push-people-picker">
      {value.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {value.map((p) => (
            <span key={key(p)} className="inline-flex items-center gap-1 pl-3 pr-1 h-7 rounded-full bg-slate-100 text-xs font-medium text-slate-700" data-testid={`push-picked-${p.user_id}`}>
              {p.name}
              <button type="button" onClick={() => onChange(value.filter((v) => key(v) !== key(p)))} className="p-1 rounded-full hover:bg-slate-200" data-testid={`push-unpick-${p.user_id}`}><X className="w-3 h-3" /></button>
            </span>
          ))}
        </div>
      )}
      <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name or email" className="w-full h-10 px-3 rounded-lg border border-slate-200 text-sm" data-testid="push-people-search" />
      <div className="max-h-48 overflow-y-auto rounded-lg border border-slate-100 divide-y divide-slate-100">
        {hits.map((p) => (
          <button type="button" key={key(p)} onClick={() => add(p)} disabled={picked.has(key(p))} data-testid={`push-person-${p.user_id}`}
            className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm hover:bg-slate-50 disabled:opacity-40">
            <span className="flex-1 truncate text-slate-800">{p.name}</span>
            <span className="text-[11px] uppercase tracking-wide text-slate-400">{p.sub}</span>
            {p.has_app && <Smartphone className="w-3.5 h-3.5 text-emerald-600" title="Has the app" />}
          </button>
        ))}
        {!hits.length && <p className="px-3 py-2 text-xs text-slate-400">No matches</p>}
      </div>
    </div>
  );
}
